export const GLOBAL_GAMES_JACKPOT_DEFAULT_PREFIX = 'global_jackpot_';
export const JACKPOT_UPDATE_INTERVAL_TIME = 100;
